import {MapLibreMapProps} from "../MapLibreMap";
import {CountryCode} from "../location/LocationType";

export const mapCoreConfig:MapLibreMapProps = {

    /*
            //mapStyle: "/map-style/mein.json"
            mapStyle: "/map-style/stadia-outdoors.json"
            //mapStyle: "https://geoserveis.icgc.cat/contextmaps/icgc_xarxa_viaria_estandard.json"

     */
    routeProps: null!,
    preferredMapFocusOrder: ["cluster", "primary_marker", "country", "user", "defined", "default"],
    map: {
        mapStyle: 'https://tiles.openfreemap.org/styles/liberty',
        initialViewState: {
            latitude: 51.505,
            longitude: -0.09,
            zoom: 4
        },
        reuseMaps: true,
        attributionControl: {
            compact: true
        }
    },
    primaryMarker: {
        marker: null!,
        centreOnClick: false,
        iconProps: {
            color: "#dc3b4e",
            innerColor: "#FFFFFF",
            strokeColor: "#000000"
        },
        defaultZIndex: 4,
        defaultZoomLevel: 10
    },
    userMarker: {
        marker: null!,
        popupContent: "Your Location",
        centreOnClick: false,
        iconProps: {
            color: "#3bbedc",
            innerColor: "#FFFFFF",
            strokeColor: "#000000"
        },
        defaultZIndex: 5
    },
    cluster: {
        layer: {
            id: 'clusters',
            source: 'mapCluster',
            type: 'circle',
        },
        source: {
            clusterMaxZoom: 14,
            clusterRadius: 40,
            cluster: true,
            type: 'geojson',
            data: '',
        },

        marker: {
            marker: null!,
            centreOnClick: false,
            iconProps: {
                color: "#7b3bdc",
                innerColor: "#FFFFFF",
                strokeColor: "#000000",
            },
            defaultZIndex: 3
        },
        clusterIcon: {
            getColor: (itemCount:number) =>
            {
                if(itemCount >= 10){
                    return "#f8dd62"
                }
                return "rgb(86,127,225)"
            },
            getStrokeColor: (itemCount:number) =>
            {
                if(itemCount >= 10){
                    return "#c5b264"
                }
                return "rgb(81 108 170)"
            },
            getTextColor: (itemCount:number) =>
            {
                if(itemCount >= 10){
                    return "#494229"
                }
                return "#ffffff"
            },
            getItemCountAbbreviated(itemCount:number) {
                if(itemCount >= 100){
                    return "99+"
                }
                return itemCount.toString();
            }
        },
        zIndex: 1,
        buttonZIndex: 2,
        withUser: false,
        withPrimaryMarker: true,
        sortByNorthWest: true,
        transitionOnClusterChange: true
    },
    geolocateControl:{
        position: "top-left",
    },
    fullscreenControl:{
        position: "top-left",
    },
    navigationControl:{
        position: "top-left",
    },
    scaleControl:{
        position: "top-left",
    },
    enableContextMenu: true,
    limitFlyToCurve: 1,
    popup: {
        closeOnMapClick: true,
        closeOnEscape: true,
        preventDefaultScroll: true
    }
}

export const primaryCountryCode:CountryCode = "gb";